<template>
  <div>
    <v-autocomplete
      outlined
      v-if="readonly === false"
      dense
      v-model="select"
      :items="Lista"
      item-text="descripcion_sr"
      item-value="id_sr"
      label="Categoria"
      persistent-hint
      return-object
      @change="$emit('input', select.id_sr)"
      hide-details
    ></v-autocomplete>
    <v-text-field
      outlined
      dense
      label="Categoria"
      v-if="readonly===true"
      readonly
      filled
      :value="select.descripcion_sr"
      hide-details
    ></v-text-field>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
export default {
  props: {
    value: Number,
    readonly: {
      type: Boolean,
      default: false
    }
  },
  data: function() {
    return {
      select: {
        id_sr: 0,
        descripcion_sr: ""
      }
    };
  },
  computed: {
    ...mapState("situacionrevista", ["Lista"]),
    lista: function() {
      let l = [...this.Lista];
      l.push({
        id_sr: 0,
        descripcion_sr: " --Seleccione-- "
      });
      return l;
    }
  },
  methods: {
    seleccionar(id) {
      if (id) {
        let pr = this.lista.find(x => x.id_sr == id);
        if (pr) {
          this.select = pr;
        } else {
          this.seleccionar("0");
        }
      }
    }
  },
  async mounted() {
    let id = this.value;
    this.seleccionar(id);
  },
  watch: {
    value: function(newVal, oldVal) {
      this.seleccionar(newVal);
    }
  }
};
</script>

<style>
</style>